// extracted by mini-css-extract-plugin
export default {"container":"Products_container__rvHpl","products":"Products_products__BkOXf","menu":"Products_menu__NKkPx","list":"Products_list__J3XNe","product":"Products_product__Vr3GP"};